export default {"src":"/_next/static/media/telegram.642afe0d.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};